// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserSettingsPage_profileSection__0s13v {
  padding: 16px 24px;
}
.UserSettingsPage_profileSection__0s13v .UserSettingsPage_title__aM-en {
  margin-bottom: 16px;
  text-align: left;
}
.UserSettingsPage_profileSection__0s13v .UserSettingsPage_title__aM-en h1 {
  font: var(--h3);
  font-weight: 600;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
  text-align: left;
}

@media (max-width: 767px) {
  .UserSettingsPage_profileSection__0s13v {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/settings/UserSettingsPage.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;AACC;EACC,mBAAA;EACA,gBAAA;AACF;AACE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gBAAA;AACH;;AAIA;EACC;IACC,aAAA;EADA;AACF","sourcesContent":[".profileSection {\r\n\tpadding: 16px 24px;\r\n\r\n\t.title {\r\n\t\tmargin-bottom: 16px;\r\n\t\ttext-align: left;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t\ttext-align: left;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.profileSection {\r\n\t\tpadding: 16px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileSection": `UserSettingsPage_profileSection__0s13v`,
	"title": `UserSettingsPage_title__aM-en`
};
export default ___CSS_LOADER_EXPORT___;
